export default __webpack_public_path__ + "static/media/edit-2.e71e28b0.svg";